<template>
  <div class="new_link">
    <router-link :to="href">
      <a>
        <font-awesome-icon class="label" icon="caret-right" />
        <span class="link-text">{{label}}</span>
      </a>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    //链接跳转
    href: {
      type: Object
    },
    //文字描述
    label: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.new_link {
  text-align: left;
  font-size: 16px;
  padding: 5px 0;
  a {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    &:hover {
      text-decoration: none;
      color: #0c82ff;
    }
    .link-text {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .label {
    font-size: 18px;
    color: #d4d4d4;
    margin: 0 10px;
  }
}
</style>

